module.exports = __webpack_public_path__ + "static/media/rainbowSixSiege@2x.a47c62ea.png";